import { Injectable } from '@angular/core';
import { DepartmentManagementService } from './serves/bdp-http-serves/department-management.service';
import { CommonService } from './serves/bdp-http-serves/common.service';
import { PositionManagementService } from './serves/bdp-http-serves/position-management.service';
import { JobManagementService } from './serves/bdp-http-serves/job-management.service';
import { RoleManagementService } from './serves/bdp-http-serves/role-management.service';
import { UserManagementService } from './serves/bdp-http-serves/user-management.service';
import { MenuManagementService } from './serves/bdp-http-serves/menu-management.service';
import { InterfacePermissionsService } from './serves/bdp-http-serves/interface-permissions.service';
import { DataPermissionService } from './serves/bdp-http-serves/data-permission.service';
import { DataManagementService } from './serves/bdp-http-serves/data-management.service';
import { FunctionalJurisdictionService } from './serves/bdp-http-serves/functional-jurisdiction.service';
import { EntityManagementService } from './serves/bdp-http-serves/entity-management.service';
import { TableManagementService } from './serves/bdp-http-serves/table-management.service';
import { ConfigDataSourceService } from './serves/bdp-http-serves/config-data-source.service';
import { FormDesignService } from './serves/bdp-http-serves/form-design.service';
import { LogLoginService } from './serves/bdp-http-serves/log-login.service';
import { LogOpetationService } from './serves/bdp-http-serves/log-operation.service';
import { LogErrorService } from './serves/bdp-http-serves/log-error.service';
import {  ConfigurationParameterService } from './serves/bdp-http-serves/configuration-parameter.service';
import { DictionaryService } from './serves/bdp-http-serves/dictionary.service';
import { InvoiceCodeService } from './serves/bdp-http-serves/invoice-code.service';
import { AdministrativeDivisionService } from './serves/bdp-http-serves/administrative-division.service';
import { AreasSystemService } from './serves/bdp-http-serves/areas-system.service';
import { DocumentTypeService } from './serves/bdp-http-serves/document-type.service';
import { DocumentCenterService } from './serves/bdp-http-serves/document-center.service';
import { WatermarkService } from './serves/bdp-http-serves/watermark.service';
import { PartnerManageService } from './serves/bdp-http-serves/partner-manage.service';
import { WhiteMenuManageService }from './serves/bdp-http-serves/white-menu-manage.service';
import { ScheduleTaskManageService } from './serves/bdp-http-serves/schedule-task-manage.service';
import { InterfaceMaintainService } from './serves/bdp-http-serves/interface-maintain.service';
import { RuleService } from './serves/bdp-http-serves/rule.service';
import { DepartmentJurisdictionService } from './serves/bdp-http-serves/department-jurisdiction.service';
import { BusinessMaintainService } from './serves/bdp-http-serves/business-maintain.service';
import { BusinessPermissionService } from './serves/bdp-http-serves/business-permission.service';
import { ProductManageService } from './serves/saas/product-manage.service';
import { SystemProductManageService } from './serves/saas/system-product-manage.service';
import { CustomerApplyManageService } from './serves/saas/customer-apply-manage.service';
import { LoginStatisticService } from './serves/bdp-http-serves/login-statistic.service';
import { CustomerUserService } from './serves/saas/customer-user.service';
import { SaasUserManageService } from './serves/saas/saas-user-manage.service';
import {productSuiteManageService} from './serves/saas/product-suite-manage.service';
import { WidgetManageService } from './serves/bdp-http-serves/widget-manage.service';
import { NoticeManagementService } from './serves/bdp-http-serves/notice-management.service';
import { ApiStatisticService } from './serves/bdp-http-serves/api-statistic.service';
import { PointsRuleService } from './serves/saas/points-rule.service';
import { PointsUserService } from './serves/saas/points-user.service';
import { ResourceManageService } from './serves/saas/resource-manage.service';
import { ServiceManageService } from './serves/saas/service-manage.service';
import { DingtalkPermissionService } from './serves/saas/dingtalk-permission.service';
@Injectable({
  providedIn: 'root'
})
export class BdpService {
  constructor(
    private departmentService: DepartmentManagementService,
    private commonService: CommonService,
    private positionService: PositionManagementService,
    private jobService: JobManagementService,
    private ruleService:RuleService,
    private roleService: RoleManagementService,
    private userService: UserManagementService,
    private menuService: MenuManagementService,
    private interfaceService: InterfacePermissionsService,
    private dataPermissionService: DataPermissionService,
    private dataManagementService: DataManagementService,
    private functionalService: FunctionalJurisdictionService,
    private entityService: EntityManagementService,
    private tableService: TableManagementService,
    private configDataService: ConfigDataSourceService,
    private formDesignService: FormDesignService,
    private logLoginService: LogLoginService,
    private logOpetationService: LogOpetationService,
    private logErrorService: LogErrorService,
    private configurationService:  ConfigurationParameterService,
    private dictionaryService: DictionaryService,
    private invoiceCodeService: InvoiceCodeService,
    private administrativeService: AdministrativeDivisionService,
    private areasSystemService: AreasSystemService,
    private documentTypeService : DocumentTypeService,
    private documentCenterService: DocumentCenterService,
    private watermarkService: WatermarkService,
    private partnerService: PartnerManageService,
    private whiteMenuService: WhiteMenuManageService,
    private scheduleTaskService: ScheduleTaskManageService,
    private interfaceMaintainService: InterfaceMaintainService,
    private DepartmentJurisdictionService: DepartmentJurisdictionService,
    private BusinessMaintainService: BusinessMaintainService,
    private BusinessPermissionService: BusinessPermissionService,
    private productManageService: ProductManageService,
    private systemProductManageService: SystemProductManageService,
    private customerApplyManageService: CustomerApplyManageService,
    private loginStatisticService: LoginStatisticService,    
    private customerUserService: CustomerUserService,
    private SaasUserManageService:SaasUserManageService,
    private productSuiteManageService:productSuiteManageService,
    private widgetManageService :WidgetManageService,
    private noticeManagementService : NoticeManagementService,
    private ApiStatisticService: ApiStatisticService,
    private PointsRuleService: PointsRuleService,
    private PointsUserService:PointsUserService,
    private ResourceManageService:ResourceManageService,
    private ServiceManageService:ServiceManageService,
    private DingtalkPermissionService:DingtalkPermissionService
  ) {
  }

  //#region 公共
    getCommonService() {
      return this.commonService;
    }
  //#endregion

  //#region 组织管理接口
    getDepartmentService() {
      return this.departmentService
    }
  //#endregion

  //#region 岗位管理接口
    getPositionService() {
      return this.positionService;
    }
  //#endregion

  //#region 岗位级别接口
    getJobService() {
      return this.jobService;
    }
  //#endregion

  //#region 角色管理接口
    getRoleService() {
      return this.roleService;
    }
  //#endregion

  //#region 用户管理接口
    getUserService() { 
       return this.userService;
    }
  //#endregion

  //#region 菜单管理接口
    getMenuService() {
      return this.menuService;
    }
  //#endregion

  //#region 接口权限接口
    getInterfaceService() {
      return this.interfaceService;
    }
  //#endregion

  //#region 接口维护接口
    getInterfaceMaintainService() {
      return this.interfaceMaintainService;
    }
  //#endregion

  //#region 数据权限接口
    getDataPermissionService() {
      return this.dataPermissionService;
    }
  //#endregion

  //#region 权限管理接口
    getDataManagementService() {
      return this.dataManagementService;
    }
  //#endregion

  //#region 功能权限接口
    getFunctionalService() {
       return this.functionalService;
    }
  //#endregion

    //#region 组织权限接口
    getDepartmentJurisdictionService() {
      return this.DepartmentJurisdictionService;
   }
 //#endregion

     //#region 业务维护接口
     getBusinessMaintainService() {
      return this.BusinessMaintainService;
   }
 //#endregion

     //#region 业务权限接口
     getBusinessPermissionService() {
      return this.BusinessPermissionService;
   }
 //#endregion

     //#region 钉钉应用权限接口
     getDingtalkPermissionService() {
      return this.DingtalkPermissionService;
   }
 //#endregion

  //#region 实体表接口
    getEntityService() {
      return this.entityService;
    }
  //#endregion

  //#region 数据表接口
    getTableService() {
      return this.tableService;
    }
  //#endregion

  //#region 数据字段管理接口
    getConfigDataService() {
      return this.configDataService;
    }
  //#endregion

  //#region 流程部署接口
  //#endregion

  //#region 流程管理接口
  //#endregion

  //#region 流程模版接口
  //#endregion

  //#region 表单设计接口
    getFormDesignService() {
      return this.formDesignService;
    }
  //#endregion

  //#region 登录日志接口
    getLogLoginService() {
      return this.logLoginService;
    }
  //#endregion

  //#region 操作日志接口
    getLogOpetationService() {
      return this.logOpetationService;
    }
  //#endregion

  //#region 错误日志接口
    getLogErrorService() {
      return this.logErrorService;
    }
  //#endregion

  //#region 系统配置接口
    getConfigurationService() {
      return this.configurationService;
    }
  //#endregion

  //#region 通用字典接口
    getDictionaryService() {
      return this.dictionaryService;
    }
  //#endregion

  //#region 单据编码接口
    getInvoiceCodeService() {
      return this.invoiceCodeService;
    }
  //#endregion

  //#region 行政区域接口
    getAdministrativeService() {
      return this.administrativeService;
    }
  //#endregion

  //#region 应用系统接口
    getAreasSystemService() {
      return this.areasSystemService;
    }
  //#endregion

  //#region 文件策略接口
    getDocumentTypeService() {
      return this.documentTypeService
    }
  //#endregion

  //#region 文件中心接口
    getDocumentCenterService() {
      return this.documentCenterService;
    }
  //#endregion

  //#region 水印设置接口
    getWatermarkService() {
      return this.watermarkService;
    }
  //#endregion

  //#region 合作方设置接口
    getPartnerService() {
      return this.partnerService;
    }
  //#endregion

  //#region 白名单设置接口
    getWhiteMenuService() {
      return this.whiteMenuService;
    }
  //#endregion

  //#region 任务调度设置接口
    getScheduleTaskService() {
       return this.scheduleTaskService;
    }
  //#endregion


  //#region 规则引擎
    getRuleService(){
      return  this.ruleService;
    }
  //#endregion

   //#region 产品设置接口
   getProductManageService(){
    return  this.productManageService;
  }
  //#endregion

  //#region 系统产品设置接口
  getSystemProductManageService(){
    return  this.systemProductManageService;
  }
  //#endregion


  //#region 平台用户申请接口
  getCustomerApplyManageService(){
    return  this.customerApplyManageService;
  }
  //#endregion

  //#region 登录统计接口
  getLoginStatisticService(){
    return  this.loginStatisticService;
  }
  //#endregion

  //#region 客户用户绑定接口
  getCustomerUserService(){
    return  this.customerUserService;
  }
  //#endregion

  //#region saas用户接口
    getSaasUsermanageService(){
      return  this.SaasUserManageService;
    }
  //#endregion

    //#region saas产品套件接口
    getProductSuiteManageService(){
      return  this.productSuiteManageService;
    }
  //#endregion

  //#region 工作台组件接口
  getWidgetManageService(){
    return  this.widgetManageService;
  }
  //#endregion

  //#region 通知公告接口
  getNoticeManagementService(){
    return  this.noticeManagementService;
  }
  //#endregion

    //#region 岗位管理接口
    getApiStatisticService() {
      return this.ApiStatisticService;
    }
    //#endregion
      //#region 规则积分接口
  getPointsRuleService() {
    return this.PointsRuleService;
  }
  //#endregion

  getPointsUserService() {
    return this.PointsUserService;
  }

    //#region Saas资源
    getResourceManageService() {
      return this.ResourceManageService;
    }
  //#endregion
    //#region Saas服务
    getServiceManageService() {
      return this.ServiceManageService;
    }
  //#endregion
}


